/**
 * The names the sidebar and the account menu show. A page's first crumb is one
 * of the groups and its clickable list crumb one of the pages, so both the
 * sidebar (AppSidebar.vue) and every view's `#breadcrumb` read from here and
 * cannot drift apart. Add a label here first; never type one inline.
 */
export const navLabels = {
  home: 'Home',
  // ── Sidebar groups / account-menu sections — always the first, inert crumb ──
  // Drafts is both the sidebar row and the list page it opens: the documents a
  // user is drafting from templates, finished ones included.
  draft: 'Drafts',
  review: 'Review',
  sign: 'Sign',
  contractManagement: 'Contract Management',
  repository: 'Repository',
  profile: 'Profile',
  organisation: 'Organisation',
  // The profile's tab of memberships — plural, unlike the admin group above.
  organisations: 'Organisations',
  templating: 'Templating',
  adminArea: 'Admin Area',
  developer: 'Developer',

  // ── Sidebar rows / menu items — the clickable list crumb and the list title ──
  newDocument: 'New document',
  // Everything waiting on the user — reached from Home's "View all".
  actionRequired: 'Action required',
  playbooks: 'Playbooks',
  reviewProjects: 'Review Projects',
  reviews: 'Reviews',
  signatureRequests: 'Signature requests',
  views: 'Views',
  matters: 'Matters',
  calendars: 'Calendars',
  clauses: 'Clauses',
  contractTypes: 'Contract Types',
  obligations: 'Obligations',
  contractualParties: 'Contractual Parties',
  dates: 'Dates',
  fileVault: 'Contract Vault',
  // Every file that went into the contract pipeline — opened from the vault page
  // and from an upload's success toast.
  uploadHistory: 'Upload History',
  // The organisation's extraction prompts, with and without a contract type.
  prompts: 'Prompts',
  promptLibrary: 'Prompt Library',
  clauseLibrary: 'Clause Library',
  gaiaPrompts: 'GAIA Prompts',
  templates: 'Templates',
  snippets: 'Snippets',
  // Organisation › General: the org's own name, description and signing default.
  general: 'General',
  intakeAgents: 'Intake Agents',
  users: 'Users',
  people: 'People',
  agentTasks: 'Agent Tasks',
  permissions: 'Permissions',
  memories: 'Memories',
  integrations: 'Integrations',
  systemFiles: 'System Files',
  adminOrganizations: 'Admin Organizations',
  adminUsers: 'Admin Users',
  adminIntakeAgentLogs: 'Admin Intake Agent Logs',
  modelCosts: 'Model Costs',
  statistics: 'Statistics',
  designSystem: 'Design System',
  contractStateIcons: 'Contract State Icons',
  websocketDebug: 'Websocket Debug',
} as const;

export type NavLabel = (typeof navLabels)[keyof typeof navLabels];
